export default "__VITE_ASSET__B7aosR_7__"